import { insertPaperwork, selectPaperworkByPage } from "../../api";

const paperwork = {
  namespaced: true,

  state: () => ({
    paperworkCount: 0,
    paperworkList: [],
    pageNum: 0,
    pages: 0,
    limit: 12,
    total: 0,
  }),

  getters: {
    count: (state) => state.paperworkCount,
    paperworkList: (state) => state.paperworkList,
    pages: (state) => state.pages,
    total: (state) => state.total,
    limit: (state) => state.limit,
  },

  mutations: {
    SET_PAPERWORK_LIST(state, paperworkList) {
      state.paperworkList = paperworkList;
    },

    SET_PAPERWORK_COUNT(state, total) {
      state.paperworkCount = total;
    },

    SET_PAGES(state, pages) {
      state.pages = pages;
    },

    SET_TOTAL(state, total) {
      state.total = total;
    },
  },

  actions: {
    async selectByPage({ commit, state }, payload) {
      const { keyword, page } = payload;
      const response = await selectPaperworkByPage(keyword, page, state.limit);
      const { data } = response;
      commit("SET_PAPERWORK_LIST", data.list);
      commit("SET_PAPERWORK_COUNT", data.count);
      commit("SET_PAGES", data.pages);
      commit("SET_TOTAL", data.total);
    },

    // eslint-disable-next-line no-unused-vars
    async insertPaperworkByUserName({ commit }, payload) {
      const { userName, paperwork } = payload;
      return await insertPaperwork(userName, paperwork);
    },
  },
};

export default paperwork;
